import { connect } from 'react-redux';
import type { AppState } from 'state/state.model';
import type { ValidationError } from 'state/tradeAllocationForm';
import * as TradeAllocationSelectors from 'state/tradeAllocationForm/tradeAllocationForm.selector';

export interface OwnProps {
  tabId: string;
}

export interface StateProps {
  validationErrors: readonly ValidationError[];
  hiddenFields: readonly string[];
}

export type ValidationErrorsState = StateProps & OwnProps;

const noHiddenFields: readonly [] = [];

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    validationErrors: TradeAllocationSelectors.getValidationErrors(state, tabId),
    hiddenFields: noHiddenFields,
  };
};

export const connectValidationErrors = connect(mapStateToProps);
